<section class="mt-100 mb-100 pxp-no-hero">
    <div class="pxp-container pxp-single-job-content">
        <h1 class="px-4">Mijn favorieten</h1>
        <app-job-list [jobs$]="jobs"></app-job-list>
    </div>
</section>